var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScheduleTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5132_4180)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 84V0H84.5V43.75H78.2298V32.1469H58.25V43.75H52.125V32.1469H30.0592V51.8531H44.25V58.1232H30.0592V77.7298H44.25V84H0.5ZM6.77016 25.8768V6.27016H23.7891V25.8768H6.77016ZM30.0592 25.8768V6.27016H52.125V25.8768H30.0592ZM58.25 25.8768V6.27016H78.2298V25.8768H58.25ZM6.77016 51.8531V32.1469H23.7891V51.8531H6.77016ZM6.77016 77.7298V58.1232H23.7891V77.7298H6.77016Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5005 53.3629L51.6561 51.2057C52.8416 50.0192 53.834 49.0484 53.8612 49.0484C53.8885 49.0484 56.8558 51.9932 60.4554 55.5925L67 62.1365L80.1377 49L84.5 53.3623L71.3635 66.5L84.5 79.6377L80.1377 84L67 70.8635L53.8623 84L49.5 79.6377L62.6365 66.5L49.5005 53.3629Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5132_4180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#000000",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleTime);
export default __webpack_public_path__ + "static/media/icon--schedule--time.a66d72e5218cfc40e0195d957bcdf5cd.svg";
export { ForwardRef as ReactComponent };